module.exports = __webpack_public_path__ + "static/media/buyer-req-workspace-help-2.7a8f0664.svg";